import { create } from "zustand";
import EcuService, { EcuGroup } from "../api/ecuService";

interface EcuStore {
  ecus: EcuGroup[];
  fetchEcu: () => Promise<void>;
}

export const useEcuStore = create<EcuStore>((set) => ({
  ecus: [],
  fetchEcu: async () => {
    const ecuService = new EcuService();
    try {
      const ecus = await ecuService.getEcus();
      set({ ecus });
    } catch (error) {}
  }   
}));
